const QuentnAblefy = ({ fields, setFields }) => {
  return (
    <div className="column-action">
      <div className="column-action-title">Ablefy</div>
      <span className="column-action-desc">customer + secret product</span>
    </div>
  )
}

export default QuentnAblefy
